import isNil from 'lodash/isNil';
import { MigrationManifest } from 'redux-persist';

import { TankChartType } from 'components/features/samplePoint/SamplePointSampleChart/sampleChartType.enum';

import { LocalUserSettingsState } from './types';

const LEGACY_TANK_CHART_TYPE_MAP: Record<string, TankChartType> = {
  units: TankChartType.LEVEL,
  percent: TankChartType.PERCENT,
  litres: TankChartType.LITRES,
  gallons: TankChartType.GALLONS
};

const migrateTankChartTypeValue = (
  value: TankChartType | null | string | undefined
): TankChartType | null => {
  if (isNil(value)) {
    return null;
  }
  return LEGACY_TANK_CHART_TYPE_MAP[value] ?? (value as TankChartType);
};

const migrateTankChartTypes = (state: LocalUserSettingsState): LocalUserSettingsState => ({
  ...state,
  waterLevelChartType: migrateTankChartTypeValue(state.waterLevelChartType),
  fuelLevelChartType: migrateTankChartTypeValue(state.fuelLevelChartType),
  liquidFertiliserLevelChartType: migrateTankChartTypeValue(state.liquidFertiliserLevelChartType)
});

const migrations = {
  1: (state: any) => migrateTankChartTypes(state)
} as unknown as MigrationManifest;

export default migrations;
